// src/views/admin/clients/index.jsx
import { useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import React, { useEffect } from 'react';
import { getData, postData } from '../../../utils/httpClient.js';
import { useSearch } from '../../../contexts/SearchContext.js';
import CreateInvoice from '../../../components/CreateInvoice/CreateInvoice.js';

export default function CreateInvoiceView() {
  const { resetListFilters } = useSearch();
  const toast = useToast();

  const handleSubmit = async (formData) => {
    try {
      // Assuming postData is a function that sends a POST request
      const response = await postData('/invoices', formData);
      
      toast({
        title: 'Factura creada',
        description: 'Abriendo PDF automáticamente...',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      // Auto-abrir PDF si la factura se creó exitosamente
      if (response?.payload?.invoice) {
        try {
          // FEU PDF se obtiene por id interno del comprobante, no por número
          const docId =
            response.payload.invoice.id || response.payload.invoice.numero;
          const pdfResponse = await getData(`/invoices/document/${docId}`);
          
          if (pdfResponse?.payload?.document) {
            const base64Data = pdfResponse.payload.document.data;
            const mimeType = pdfResponse.payload.document.mime_type || 'application/pdf';

            // Convertir base64 a Blob
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length)
              .fill(0)
              .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });

            // Crear URL y abrir en nueva pestaña
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
            
            // Limpiar la URL del blob después de unos segundos
            setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
          }
        } catch (pdfError) {
          console.error('Error al abrir PDF:', pdfError);
          toast({
            title: 'Factura creada, pero no se pudo abrir el PDF',
            description: 'Puedes encontrarla en Facturas emitidas e imprimirla desde ahí',
            status: 'warning',
            duration: 5000,
            isClosable: true,
          });
        }
      }
      
    } catch (error) {
      console.error('Error creating invoice:', error);
      toast({
        title: 'Error al crear factura',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Hubo un error al crear la factura. Por favor, inténtalo de nuevo.',
        status: 'error',
        duration: 6000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AdminPageShell title="Emitir factura">
      <CreateInvoice onSubmit={handleSubmit} />
    </AdminPageShell>
  );
}
